// AUTO-GENERATED by ExternalStubPlugin — do not edit.
// Re-exports of globalThis.$scramjet (set by the IIFE bundle).
const __external = /** @type {any} */ (globalThis).$scramjet;
export const {
	BareResponse,
	CookieJar,
	IncrementalHtmlRewriter,
	Plugin,
	SCRAMJETCLIENT,
	SCRAMJETCLIENTNAME,
	ScramjetClient,
	ScramjetFetchHandler,
	ScramjetFetchTrackedClient,
	ScramjetHeaders,
	Tap,
	createLocationProxy,
	defaultConfig,
	defaultConfigDev,
	flagEnabled,
	getOwnPropertyDescriptorHandler,
	getRewriter,
	getScriptBlockTypeString,
	htmlRules,
	isArchiveMimeType,
	isAudioOrVideoMimeType,
	isFontMimeType,
	isHtmlMimeType,
	isImageMimeType,
	isInlineDisplayableMimeType,
	isJavascriptMimeType,
	isJavascriptMimeTypeEssenceMatch,
	isModuleScriptType,
	isScriptType,
	isScriptableMimeType,
	isXmlMimeType,
	isZipBasedMimeType,
	isdedicated,
	isshared,
	issw,
	iswindow,
	isworker,
	parseMimeType,
	rewriteBlob,
	rewriteCss,
	rewriteHtml,
	rewriteJs,
	rewriteJsInner,
	rewriteSrcset,
	rewriteUrl,
	rewriteWorkers,
	setWasm,
	unrewriteBlob,
	unrewriteCss,
	unrewriteHtml,
	unrewriteUrl,
	versionInfo,
} = __external;
